import { render, staticRenderFns } from "./snippletImport.vue?vue&type=template&id=adc3fa54"
import script from "./snippletImport.vue?vue&type=script&lang=js"
export * from "./snippletImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports